"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocket = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const ConfigContext_1 = require("../lib/ConfigContext");
const LoggerContext_1 = require("../lib/LoggerContext");
const SocketService_1 = require("../util/socket/SocketService");
const useSocket = () => {
    let socketService;
    const { state: { socketUserToken }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    const { logWarn } = (0, LoggerContext_1.useLoggerContext)();
    const initializeSocket = (app, nameSpace, params, token) => {
        socketService = new SocketService_1.SocketService(token || socketUserToken, {
            socketUrl: config.WEBSOCKET_ENDPOINT,
            nameSpace,
            params: {
                ...(params || {}),
                app,
            },
        }, logWarn);
    };
    const createDomainEventsListeners = (domainEvents) => {
        if (socketService) {
            socketService.createDomainEventsListeners(domainEvents);
        }
    };
    const disconnectSocket = () => {
        if (socketService) {
            socketService.disconnect();
        }
    };
    return { initializeSocket, createDomainEventsListeners, disconnectSocket };
};
exports.useSocket = useSocket;
//# sourceMappingURL=useSocket.js.map